var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRowMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-mail",
    "data-name": "Icon ionic-ios-mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.001,
    height: 11.77,
    viewBox: "0 0 17.001 11.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M20.237,10.339l-4.4,4.479a.079.079,0,0,0,0,.114l3.077,3.278a.53.53,0,0,1,0,.752.533.533,0,0,1-.752,0L15.1,15.7a.084.084,0,0,0-.119,0l-.748.76a3.29,3.29,0,0,1-2.346.989,3.356,3.356,0,0,1-2.395-1.018L8.774,15.7a.084.084,0,0,0-.119,0L5.59,18.962a.533.533,0,0,1-.752,0,.53.53,0,0,1,0-.752l3.077-3.278a.087.087,0,0,0,0-.114l-4.4-4.479a.081.081,0,0,0-.139.057v8.962a1.312,1.312,0,0,0,1.308,1.308H19.068a1.312,1.312,0,0,0,1.308-1.308V10.4A.082.082,0,0,0,20.237,10.339Z",
    transform: "translate(-3.375 -8.896)",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M12.232,15.358a2.222,2.222,0,0,0,1.6-.67l6.412-6.527a1.284,1.284,0,0,0-.809-.286H5.035a1.276,1.276,0,0,0-.809.286l6.412,6.527A2.222,2.222,0,0,0,12.232,15.358Z",
    transform: "translate(-3.731 -7.875)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowMail);
export default __webpack_public_path__ + "static/media/row-mail.79b8ba8b048276dfba5e328911f7b5e6.svg";
export { ForwardRef as ReactComponent };